import React from "react";

// Bootstrap collapse card used for the Customer, Store and Rider sections
export default function InfoAccordion({ parentId, itemId, title, children }) {
  return (
    <div className="accordion mb-3" id={parentId}>
      <div className="card">
        <div className="card-header header-elements-inline">
          <h3 className="card-title ul-collapse__icon--size ul-collapse__right-icon mb-0">
            <a
              className="text-default collapsed"
              data-toggle="collapse"
              href={`#${itemId}`}
              aria-expanded="false"
            >
              {title}
            </a>
          </h3>
        </div>
        <div className="collapse" id={itemId} data-parent={`#${parentId}`}>
          {children}
        </div>
      </div>
    </div>
  );
}
